let React = require('react');
import TipoTarjetaItem from './TipoTarjetaItem.jsx';
import { GenericOption, GenericSelect } from 'com-gyf-webcore-userinterfacecomponents';

let TipoTarjeta = React.createClass({
    render: function () {
        let tipos;
        let props = this.props;
        let idTipoTarjeta;

        if (this.props.data != undefined && this.props.data != "") {
           
            let cards = JSON.parse(JSON.stringify(this.props.data.tipoTarjeta));

            idTipoTarjeta = props.data.idTipoTarjeta != undefined ? props.data.idTipoTarjeta : "0";
            //cards.unshift({ Id: 0, Descripcion: "Seleccione..." });
           
            tipos = cards.map(function (row) {
                let selected = row.Id == 0 ? true : false;
                selected = (idTipoTarjeta == row.Id) ? true : false;
                return (
                    <option value={row.Id} key={"KindCardItem_" + row.Id} >
                        { row.Descripcion }
                    </option>
                   /* <GenericOption selected={selected} id={row.Id} description={row.Descripcion} key={"KindCardItem_" + row.Id} />*/
                );
            })
        };

        return (
            <div>
                {/*<GenericSelect id="selCards" className="form-control default-select" options={tipos} onChange={(event) => this.changeKind(event)} />*/}
                <select value={idTipoTarjeta} className="form-control default-select" onChange={(event) => this.changeKind(event)} >
                    <option value="0">Seleccione...</option>
                    {tipos}
                </select>
                {this.props.data.ERROR_CARD["seleccionoTipoTarjeta"] == false ? <label className="error">Debe seleccionar al menos un tipo de tarjeta.</label> : null }
            </div>
        );
    },
    
    changeKind: function (event) {
        //if (event.target.value === "0") {
        //    return;
        //}
        this.props.getKind(event.target.value);
    }

});

export default TipoTarjeta